import { PAYMENT_TYPE } from '../constants/global'
import { PAYMENT_TYPE_CODE } from '../constants/global'
import {
  PARAM_APIKEY,
  PARAM_HIDE_PAYMENT_METHOD,
  PARAM_ENABLE_AUTO_RENEW,
  PARAM_IS_EMBEDDED_VIEW,
  PARAM_IS_HEADER_MINI_APP,
  PARAM_IS_HEADER_MINI_APP_EXPAND,
  PARAM_PAYMENT_METHOD,
  PARAM_REFER_STATION_CODE,
  PARAM_REFER_STATION_ID,
  PARAM_REFER_USER_CODE,
  PARAM_REFER_USER_ID,
  PARAM_USERNAME_PREFIX,
  PARAM_APP_THEME_NAME,
  PARAM_IS_DISPLAY_REFER_USER_CODE,
  PARAM_PARTNER_NAME
} from '../constants/params'
import { SessionStorageManager } from '../helper/localStorage'
import { smartParseParam } from '../helper/params'
import { getUrlParamValue } from '../helper/params'
import React from 'react'
export const AppParamsContext = React.createContext(null)

const resolveParamsMiniApp = (config) => {
  // 1. param (raw)
  const param = getUrlParamValue(config.paramKey)

  // có param thì lưu session (raw)
  if (param !== null && param !== undefined) {
    SessionStorageManager.setItem(config.storageKey, param)
  }

  // 2. resolve raw theo thứ tự ưu tiên
  const raw = param ?? SessionStorageManager.getItem(config.storageKey) ?? smartParseParam(process.env?.[config.envKey]) ?? config.defaultValue

  // 3. parse giá trị cuối cùng
  return config.parser ? config.parser(raw) : raw
}

/* =====================
 * PARAM MINI APP SCHEMA
 * ===================== */
const PARAMS_MINIAPP_SCHEMA = {
  apikey: {
    paramKey: PARAM_APIKEY,
    storageKey: PARAM_APIKEY,
    envKey: 'REACT_APP_APIKEY',
    defaultValue: undefined,
    parser: (v) => v
  },
  partnerName: {
    paramKey: PARAM_PARTNER_NAME,
    storageKey: PARAM_PARTNER_NAME,
    envKey: 'REACT_APP_PARTNER_NAME',
    defaultValue: undefined,
    parser: (v) => v
  },
  isEmbeddedView: {
    paramKey: PARAM_IS_EMBEDDED_VIEW,
    storageKey: PARAM_IS_EMBEDDED_VIEW,
    envKey: 'REACT_APP_PARAM_IS_EMBEDDED_VIEW',
    defaultValue: false,
    parser: (v) => v === true || v === 1
  },
  isHeaderMiniApp: {
    paramKey: PARAM_IS_HEADER_MINI_APP,
    storageKey: PARAM_IS_HEADER_MINI_APP,
    envKey: 'REACT_APP_PARAM_IS_HEADER_MINI_APP',
    defaultValue: undefined,
    parser: (v) => v === true || v === 1
  },
  isHeaderMiniAppExpand: {
    paramKey: PARAM_IS_HEADER_MINI_APP_EXPAND,
    storageKey: PARAM_IS_HEADER_MINI_APP_EXPAND,
    envKey: undefined,
    defaultValue: false,
    parser: (v) => v === true || v === 1
  },
  paymentMethodType: {
    paramKey: PARAM_PAYMENT_METHOD,
    storageKey: PARAM_PAYMENT_METHOD,
    envKey: 'REACT_APP_PAYMENT_METHOD',
    defaultValue: undefined,
    parser: (v) => {
      const paymentMethod = (v || '')?.toLowerCase()
      const paymentMethods = Object.values(PAYMENT_TYPE_CODE).map((item) => item.toLowerCase())

      if (paymentMethods.includes(paymentMethod)) {
        const key = Object.keys(PAYMENT_TYPE_CODE).find((k) => PAYMENT_TYPE_CODE[k].toLowerCase() === paymentMethod)
        const paymentMethodType = PAYMENT_TYPE[key]
        return paymentMethodType
      }
      return undefined
    }
  },
  hidePaymentMethod: {
    paramKey: PARAM_HIDE_PAYMENT_METHOD,
    storageKey: PARAM_HIDE_PAYMENT_METHOD,
    envKey: 'REACT_APP_HIDE_PAYMENT_METHOD',
    defaultValue: false,
    parser: (v) => v === true || v === 1
  },
  enableAutoRenew: {
    paramKey: PARAM_ENABLE_AUTO_RENEW,
    storageKey: PARAM_ENABLE_AUTO_RENEW,
    envKey: 'REACT_APP_ENABLE_AUTO_RENEW',
    defaultValue: false,
    parser: (v) => v === true || v === 1
  },
  usernamePrefix: {
    paramKey: PARAM_USERNAME_PREFIX,
    storageKey: PARAM_USERNAME_PREFIX,
    envKey: 'REACT_APP_USERNAME_PREFIX',
    defaultValue: false,
    parser: (v) => v
  },
  referStationId: {
  paramKey: PARAM_REFER_STATION_ID,
  storageKey: PARAM_REFER_STATION_ID,
  envKey: 'REACT_APP_REFER_STATION_ID',
  defaultValue: undefined,
  parser: (v) => {
    const n = Number(v)
    return Number.isFinite(n) ? n : undefined
    }
  },
  referUserId: {
    paramKey: PARAM_REFER_USER_ID,
    storageKey: PARAM_REFER_USER_ID,
    envKey: 'REACT_APP_REFER_USER_ID',
    defaultValue: undefined,
    parser: (v) => {
      const n = Number(v)
      return Number.isFinite(n) ? n : undefined
    }
  },
  referStationCode: {
    paramKey: PARAM_REFER_STATION_CODE,
    storageKey: PARAM_REFER_STATION_CODE,
    envKey: 'REACT_APP_REFER_STATION_CODE',
    defaultValue: undefined,
    parser: (v) => (v ? String(v).trim() : undefined)
  },
  referUserCode: {
    paramKey: PARAM_REFER_USER_CODE,
    storageKey: PARAM_REFER_USER_CODE,
    envKey: 'REACT_APP_REFER_USER_CODE',
    defaultValue: undefined,
    parser: (v) => (v ? String(v).toUpperCase().replace(/[^0-9A-F]/g, '') : undefined)
  },
  isDisplayReferUserCode: {
    paramKey: PARAM_IS_DISPLAY_REFER_USER_CODE,
    storageKey: PARAM_IS_DISPLAY_REFER_USER_CODE,
    envKey: 'REACT_APP_IS_DISPLAY_REFER_USER_CODE',
    defaultValue: true,
    parser: (v) => v !== false && v !== 0 && v !== '0' && v !== 'false'
  },
  appThemeName: {
    paramKey: PARAM_APP_THEME_NAME,
    storageKey: PARAM_APP_THEME_NAME,
    envKey: 'REACT_APP_THEME_NAME',
    defaultValue: 'TAMOVE',
    parser: (v) => v
  }
}

export const AppParamsContextProvider = (props) => {
  const paramsMiniApp = React.useMemo(() => {
    const params = {}

    Object.keys(PARAMS_MINIAPP_SCHEMA).forEach((key) => {
      params[key] = resolveParamsMiniApp(PARAMS_MINIAPP_SCHEMA[key])
    })

    return params
  }, [])

  // pass resolved params through context value
  return React.createElement(AppParamsContext.Provider, { value: paramsMiniApp }, props.children)
}
export const useAppParamsContext = () => {
  const context = React.useContext(AppParamsContext)
  if (!context) {
    throw new Error('useAppParamsContext must be used within AppParamsContextProvider')
  }
  return context
}
